<template>
  <div class="tabs-container">
    <el-tabs v-model="activeTabName" type="border-card" :closable="isEdit" @tab-remove="handleTabRemove">
      <el-tab-pane v-for="item in usCustomsClearanceListFilter" :key="item._title" :label="item._title" :name="item._title">
        <tab-us-customs-clearance-master-item :ref="item._title" :action="action" :job="job" :form="item" :show-sync="showSync" :cooperate-edit="cooperateEdit" @chargeChange="onChargeChange" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabUsCustomsClearanceMasterItem from './tabUsCustomsClearanceMasterItem'
import moment from 'moment'
import { TabError } from '@/utils/class/TabError'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { ensureExecuteSuccess, getAllSortedRows } from '@/utils/commonUtil'
import { toStatistics } from './tabUsCustomsClearanceUtil'
import { UsCustomsClearance } from '@/class/model/booking/UsCustomsClearance'
import { getUsCustomsClearanceDetailList, getUsCustomsClearanceDetailListByJobUuids } from '@/api/booking/usCustomsClearance'
import { queryAllUSCommodityCode } from '@/api/usCommodityCode'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'TabUsCustomsClearanceMaster',
  components: { tabUsCustomsClearanceMasterItem },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    showSync: { type: Boolean, default: true },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      activeTabName: '',
      job: {},
      usCustomsClearanceList: [],
      deletedUsCustomsClearanceKeys: []
    }
  },
  computed: {
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    usCustomsClearanceListFilter() {
      const result = []
      if (this.usCustomsClearanceList && this.usCustomsClearanceList.length > 0) {
        for (const item of this.usCustomsClearanceList) {
          const dataType = item.dataType ? Number(item.dataType) : 0
          if (!dataType) continue
          if (dataType === 1 && (this.$checkPermission(['tab_UsCustomsClearance_customerView']) || this.$checkPermission(['tab_UsCustomsClearance_customerEdit']))) {
            result.push(item)
          } else if (dataType === 2 && (this.$checkPermission(['tab_UsCustomsClearance_reportView']) || this.$checkPermission(['tab_UsCustomsClearance_reportEdit']))) {
            result.push(item)
          } else if (dataType === 3 && (this.$checkPermission(['tab_UsCustomsClearance_secretView']) || this.$checkPermission(['tab_UsCustomsClearance_secretEdit']))) {
            result.push(item)
          }
        }
      }
      return result
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      let { job, usCustomsClearanceList } = this
      job = row
      if (job.uuid) {
        if (job.usCustomsClearanceList && job.usCustomsClearanceList.length > 0) {
          usCustomsClearanceList = job.usCustomsClearanceList
          for (const item of usCustomsClearanceList) {
            item.usCustomsClearanceCargoList.sort((a, b) => {
              if (a.jobNo < b.jobNo) {
                return -1
              } else if (a.jobNo > b.jobNo) {
                return 1
              } else {
                return a.serialNumber - b.serialNumber
              }
            })
          }
          this.initStatistics()
        } else {
          const loading = getLoading4Cxt(this)
          try {
            const ajaxResults = [getUsCustomsClearanceDetailList({ jobUuid: job.uuid })]
            const lclSlavesUuids = []
            const slaveUuidJobNoMap = new Map()
            for (const lclSlave of job.lclSlaves) {
              lclSlavesUuids.push(lclSlave.uuid)
              slaveUuidJobNoMap.set(lclSlave.uuid, lclSlave.jobNo)
            }
            if (lclSlavesUuids.length > 0) {
              ajaxResults.push(getUsCustomsClearanceDetailListByJobUuids({ jobUuids: lclSlavesUuids.join(',') }))
            }
            const results = await Promise.all(ajaxResults)
            usCustomsClearanceList = results[0].data
            for (const item of usCustomsClearanceList) {
              item.subUsCustomsClearance = []
              item.deletedUsCustomsClearanceCargoKeys = []
            }
            if (results.length > 1) {
              for (const item of results[1].data) {
                let masterItem = usCustomsClearanceList.find(p => p.dataType === item.dataType)
                if (masterItem) {
                  masterItem.subUsCustomsClearance.push(item)
                } else {
                  masterItem = this.getNewUsCustomsClearance()
                  masterItem.dataType = item.dataType
                  masterItem.subUsCustomsClearance.push(item)
                  usCustomsClearanceList.push(masterItem)
                }
                for (const subItem of item.usCustomsClearanceCargoList) {
                  subItem.jobUuid = item.jobUuid
                  subItem.jobNo = slaveUuidJobNoMap.get(item.jobUuid)
                  masterItem.usCustomsClearanceCargoList.push(subItem)
                }
              }
              for (const item of usCustomsClearanceList) {
                item.usCustomsClearanceCargoList.sort((a, b) => {
                  if (a.jobNo < b.jobNo) {
                    return -1
                  } else if (a.jobNo > b.jobNo) {
                    return 1
                  } else {
                    return a.serialNumber - b.serialNumber
                  }
                })
              }
              this.initStatistics()
            }
          } finally {
            loading.close()
          }
        }
      } else {
        usCustomsClearanceList = []
      }
      this.job = job
      this.usCustomsClearanceList = usCustomsClearanceList
      this.job.usCustomsClearanceList = usCustomsClearanceList
      if (this.usCustomsClearanceList.length === 0) {
        this.usCustomsClearanceList.push(this.getNewUsCustomsClearance())
      } else {
        this.usCustomsClearanceList.sort((a, b) => a.dataType - b.dataType)
      }
      this.generateTabTitles()
      this.activeTabName = this.usCustomsClearanceList[0]._title
      this.deletedUsCustomsClearanceKeys = []
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { usCustomsClearanceList: deepCopy(this.job.usCustomsClearanceList) })
      }
    },
    getNewUsCustomsClearance() {
      const newObj = new UsCustomsClearance().fillDefaultValue().getData()
      const todayStr = moment().format('YYYY-MM-DD')
      newObj.summaryDate = todayStr
      newObj.entryDate = todayStr
      newObj.importDate = todayStr
      newObj.exportDate = todayStr
      newObj.usCustomsClearanceCargoList = []
      newObj.subUsCustomsClearance = []
      newObj.deletedUsCustomsClearanceCargoKeys = []
      return newObj
    },
    // 生成页签标题
    generateTabTitles() {
      const dataTypeInfos = {
        '1': this.$t('queryJob.CustomerInformation'),
        '2': this.$t('queryJob.DeclarationMaterials'),
        '3': this.$t('queryJob.TopSecretInformation')
      }
      for (const item of this.usCustomsClearanceList) {
        item._title = dataTypeInfos[String(item.dataType)]
      }
    },
    handleTabRemove(targetName) {
      this.$confirm(this.$t('queryJob.DeletionIsUnrecoverable'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.usCustomsClearanceList.findIndex(p => p._title === targetName)
        const item = this.usCustomsClearanceList[index]
        if (item.uuid) {
          this.deletedUsCustomsClearanceKeys.push(item.uuid)
        }
        for (const subItem of this.item.subUsCustomsClearance) {
          if (subItem.uuid) {
            this.deletedUsCustomsClearanceKeys.push(subItem.uuid)
          }
        }
        this.usCustomsClearanceList.splice(index, 1)
        if (targetName === this.activeTabName) {
          if (index > 0) {
            this.activeTabName = this.usCustomsClearanceList[index - 1]._title
          } else if (index < this.usCustomsClearanceList.length) {
            this.activeTabName = this.usCustomsClearanceList[index]._title
          } else {
            this.usCustomsClearanceList.push(this.getNewUsCustomsClearance())
            this.generateTabTitles()
            this.activeTabName = this.usCustomsClearanceList[0]._title
          }
        }
      }).catch(() => { })
    },
    onChargeChange() {
      this.context.reloadCharge = true
    },
    async initStatistics() {
      const res = await queryAllUSCommodityCode()
      const usCommodityCodeList = res.data.filter(p => p.status === 1)
      for (const item of this.usCustomsClearanceListFilter) {
        const vm = this.$refs[item._title]
        // 确认有值，再往下执行
        await ensureExecuteSuccess(() => vm && (vm.gridApi || vm[0].gridApi))
        const rows = getAllSortedRows(vm.gridApi || vm[0].gridApi)
        let minJobNoRow = rows[0]
        for (let i = 1; i < rows.length; ++i) {
          if (rows[i].jobNo < minJobNoRow.jobNo) {
            minJobNoRow = rows[i]
          }
        }
        const minUsCustomsClearance = item.subUsCustomsClearance.find(p => p.uuid === minJobNoRow.usCustomsClearanceUuid)
        if (minUsCustomsClearance) {
          item.countryOfOrigin = minUsCustomsClearance.countryOfOrigin
        }
        toStatistics(rows, usCommodityCodeList, item, this.job.lob)
      }
    },
    async getSubmitData() {
      const usCustomsClearanceList = []
      let currentItem = null
      let chinaAdditionalTaxRateIsEmptyConfirm = false
      try {
        for (const item of this.usCustomsClearanceList) {
          currentItem = item
          for (let j = 0; j < item.usCustomsClearanceCargoList.length; ++j) {
            const subItem = item.usCustomsClearanceCargoList[j]
            if (!subItem.customerProductName) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('queryJob.CustomerName')), 'tabUsCustomsClearance')
            }
            if (!subItem.customsClearanceProductName) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('queryJob.CustomsClearanceProductName')), 'tabUsCustomsClearance')
            }
            if (!subItem.packageType) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('SeaExport.PackageType')), 'tabUsCustomsClearance')
            }
            if (!subItem.netWeight) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('SeaExport.NetWeight')), 'tabUsCustomsClearance')
            }
            if (!subItem.grossWeight) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('SeaExport.GrossWeight')), 'tabUsCustomsClearance')
            }
            if (!subItem.goodsNumber) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('queryJob.NumberOfGoods')), 'tabUsCustomsClearance')
            }
            if (!subItem.customsClearanceUnit) {
              throw new TabError(this.$t('queryJob.PleaseEnterOnLine').replace('{0}', j + 1).replace('{1}', this.$t('queryJob.CustomsClearanceUnit')), 'tabUsCustomsClearance')
            }
            if (!chinaAdditionalTaxRateIsEmptyConfirm && !Number(subItem.chinaAdditionalRate)) {
              chinaAdditionalTaxRateIsEmptyConfirm = true
              await this.$confirm(this.$t('CargoMsg.ChinaAdditionalTaxRateIsEmpty'), this.$t('Message.Prompt'), {
                confirmButtonText: this.$t('Message.Confirm'),
                cancelButtonText: this.$t('Message.Cancel'),
                closeOnClickModal: false,
                type: 'info'
              })
            }
          }
          usCustomsClearanceList.push(item)
          for (const subItem of item.subUsCustomsClearance) {
            subItem.generatingFileMergeSameProduct = item.generatingFileMergeSameProduct
            subItem.showTax = item.showTax
            subItem.showChinaSurtax = item.showChinaSurtax
            subItem.showBond = item.showBond
            subItem.bondAmount = item.bondAmount
            usCustomsClearanceList.push({ ...subItem, usCustomsClearanceCargoList: null, deletedUsCustomsClearanceCargoKeys: null })
          }
        }
      } catch (err) {
        if (err instanceof TabError) {
          this.activeTabName = currentItem._title
        }
        throw err
      }
      return {
        usCustomsClearanceList,
        deletedUsCustomsClearanceKeys: this.deletedUsCustomsClearanceKeys
      }
    },
    // 组装打印参数
    getPrintData() {
      if (!this.activeTabName) return
      const params = this.$refs[this.activeTabName][0].getPrintData()
      return params
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .details-view .tabs-container ::v-deep {
  padding: 10px 0 0 15px;
  .el-tabs--border-card {
    background-color: unset;
    border: unset;
    box-shadow: unset;
    > .el-tabs__header {
      background-color: transparent;
      border-bottom: 1px solid #c4c8d0 !important;
      .el-tabs__item {
        background-color: transparent;
        border: 1px solid #c4c8d0 !important;
        box-shadow: unset;
        color: #666666;
        margin: 1px 10px 0 0;
        &.is-closable {
          padding-left: 15px !important;
          span.el-icon-close {
            padding: 3px;
            font-size: 16px;
            margin-top: -3px;
          }
        }
        &.is-active {
          background-color: #ffffff;
          border-bottom: 1px solid #ffffff !important;
          color: black;
        }
      }
    }
  }
}
</style>
